import {
  type RoutineDraftSessionSnapshot,
  RoutineFormDraftSchema,
} from '@littlebird/sdk';
import { reaction } from 'mobx';
import { z } from 'zod';

import { getLocalStorageItem } from '@/utils/localStorage';

const STORAGE_KEY = 'routineDraftSessions';

const PersistedRoutineDraftsSchema = z.array(
  z.object({
    ownerId: z.string(),
    draftKey: z.union([z.number(), z.literal('create')]),
    draft: RoutineFormDraftSchema,
    baselineDraft: RoutineFormDraftSchema.optional(),
    customBackup: RoutineFormDraftSchema.optional(),
  })
);

type RoutineDraftSessions = {
  exportSessions(): RoutineDraftSessionSnapshot[];
  restoreSessions(sessions: RoutineDraftSessionSnapshot[]): void;
};

export const persistRoutineDrafts = (routineDrafts: RoutineDraftSessions) => {
  const persisted = PersistedRoutineDraftsSchema.safeParse(
    getLocalStorageItem(STORAGE_KEY)
  );
  if (persisted.success) routineDrafts.restoreSessions(persisted.data);

  return reaction(
    () => JSON.stringify(routineDrafts.exportSessions()),
    (sessions) => localStorage.setItem(STORAGE_KEY, sessions),
    { delay: 300 }
  );
};
